///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ChangeDetectionStrategy, Component, computed, EventEmitter, Input, OnInit, Output, Signal } from '@angular/core';
import { Router } from '@angular/router';
import { UserAuthorities } from '../../services/user/user-authorities';
import { FoldersTreeService, FolderTreeNode } from '../folders-tree/folders-tree.service';
import { PROJECTS_ENG_BASE_URL } from '../projects.route';
import { ProjectListViewType } from '../project-enums';
import { ProjectFolderEnum } from '../../generated/shared-types.model';
import { ProjectsViewStateService } from '../projects-view-state.service';
import { Store } from '@ngrx/store';
import { selectSystemInfo } from '../../shared/store/systemInfo/system-info.selectors';

@Component({
    selector: 'winde-tree-controls',
    templateUrl: './tree-controls.component.html',
    styleUrls: ['../projects.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GtthTreeControlsComponent implements OnInit {
    public userAuthorities = UserAuthorities;
    public viewType = ProjectListViewType;

    public isShowMenu = 'none';
    public systemInfo$ = this.store.select(selectSystemInfo);

    public selectedFolder: Signal<FolderTreeNode>;
    public isBomConfigFolderSelected: Signal<boolean>;
    public isBugReportsFolderSelected: Signal<boolean>;
    public isTableViewTypeSelected: Signal<boolean>;

    public filter: Signal<string>;
    public isFilterActive: Signal<boolean>;

    @Input() baseUrl: string;
    @Input() companyId: number;

    @Output() selectParent = new EventEmitter<void>();

    constructor(
        private readonly router: Router,
        private readonly store: Store,
        private readonly foldersTreeService: FoldersTreeService,
        private readonly projectsViewService: ProjectsViewStateService
    ) {}

    ngOnInit() {
        this.selectedFolder = this.foldersTreeService.getSelectedFolder();
        this.isBomConfigFolderSelected = computed(() => this.selectedFolder()?.type === ProjectFolderEnum.BOM_CONFIG);
        this.isBugReportsFolderSelected = computed(() => this.selectedFolder()?.type === ProjectFolderEnum.BUG_REPORT);
        this.isTableViewTypeSelected = computed(() => this.projectsViewService.currentViewType() === ProjectListViewType.TABLE);

        this.filter = this.projectsViewService.innerFilter;
        this.isFilterActive = computed(() => !!this.filter());
    }

    public openCreateDialog(url: string) {
        if (this.baseUrl === PROJECTS_ENG_BASE_URL && this.companyId) {
            url += '/' + this.companyId;
        }
        url += '/' + this.selectedFolder().id;
        this.router.navigate(['', { outlets: { popup: url } }], { queryParamsHandling: 'preserve' });
    }

    public selectParentFolder() {
        this.selectParent.emit();
    }

    public changeCurrentViewType(type: ProjectListViewType) {
        this.projectsViewService.setCurrentViewType(type);
    }

    public showSelection(isShow: boolean) {
        this.isShowMenu = isShow ? 'block' : 'none';
    }

    public changeFilter(value: string) {
        this.projectsViewService.setInnerFilter(value);
    }

    public clearFilter() {
        this.projectsViewService.setInnerFilter('');
    }
}
